"use client";

import dynamic from "next/dynamic";

const LanguagesSelectorLazy = dynamic(() => import("./LanguagesSelector"));

export default LanguagesSelectorLazy;
